import * as React from 'react'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import StraightenIcon from '@mui/icons-material/Straighten'

export default function SizeChip({ size }) {
  if (size === undefined || size === null) return null

  // Приводим к числу, если можно
  let formattedSize = size
  const parsed = parseFloat(size)

  if (!isNaN(parsed)) {
    formattedSize = Number.isInteger(parsed)
      ? parsed.toString()
      : parsed.toFixed(1)
  }

  return (
    <Stack direction="row" spacing={1}>
      <Chip
        icon={<StraightenIcon />}
        label={`Размер: ${formattedSize}`}
        variant="outlined"
      />
    </Stack>
  )
}
